import {
  FaAws,
  FaCss3,
  FaFigma,
  FaFlask,
  FaHtml5,
  FaNodeJs,
  FaPython,
  FaReact,
} from "react-icons/fa";
import {
  SiTypescript,
  SiMicrosoftazure,
  SiScikitlearn,
  SiPowerbi,
  SiPostgresql,
  SiJavascript,
} from "react-icons/si";

export const workExperiences = {
  experience: [
    {
      role: "Software Development Engineer",
      company: "Amazon",
      companylogo: require("../assets/images/amazonLogo.png"),
      date: "May,2021 - August,2021 (Intern) \n June,2022 - Present \n Vancouver",
      desc: "I interned in the Alexa Multimodal Team during the summer of 2021 and returned as a Full Time SDE in June,2022",
      descBullets: [
        "Owned a product from design to implementation",
        "Worked with technologies such as TypeScript, NodeJS, and React",
        "Collaborated with various stakeholders and other teams",
      ],
      skills: [
        <FaNodeJs />,
        <FaReact />,
        <SiTypescript />,
        <FaFigma />,
        <FaAws />,
      ],
    },
    {
      role: "Product Engineering Intern",
      company: "Ernst and Young",
      companylogo: require("../assets/images/eyLogo.png"),
      date: "May,2020 - May,2021 \n Vancouver",
      desc: "I was a part of the Client Technology Team",
      descBullets: [
        "Used PuLP to build a Constraint Optimization Model for a seating assignment problem",
        "Developed Custom Heuristics to determine the effectiveness of solution by Constraint Optimization Model",
        "Took lead in backend development of a Machine Learning web app by developing RESTful API in Flask to handle requests from front-end and fetch data from Machine Learning Pipeline",
      ],
      skills: [
        <FaPython />,
        <FaFlask />,
        <SiMicrosoftazure />,
        <SiScikitlearn />,
        <SiPostgresql />,
        <SiPowerbi />,
      ],
    },
    {
      role: "App Developer (WorkStudy)",
      company: "University of Toronto",
      companylogo: require("../assets/images/uoftLogo.png"),
      date: "September,2019 - February,2020 \n Toronto",
      desc: "I worked part time and built a cross-platform app alongside 2 other developers for the department of Italian Studies at the University of Toronto.",
      descBullets: [],
      skills: [<FaHtml5 />, <FaCss3 />, <SiJavascript />],
    },
  ],
};
